import RatingStars from 'generic/RatingStars';
import { useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import type {
  ComponentsTestimonialRating,
  ComponentsTestimonialRatingStyle,
} from 'queries/graphql';

import styles from './styles.module.scss';

export default function TestimonialRating({
  text,
  rating,
  ratingStyle,
}: ComponentsTestimonialRating & {
  ratingStyle?: ComponentsTestimonialRatingStyle;
}) {
  const { textColor, starColor, starEmptyColor, headingFont } = ratingStyle || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);
  return (
    <div className={`root ${styles.item}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
        }
        ${headingFontOverrides ?? ''}
      `}</style>

      <h4>{text}</h4>
      <div className={styles.star}>
        <div className={styles.star_wrapper}>
          <RatingStars rating={rating} style={{ starColor, starEmptyColor }} />
        </div>
        <h4>{rating?.toFixed(1)}</h4>
      </div>
    </div>
  );
}
